import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import RotateLeftTwoToneIcon from "@mui/icons-material/RotateLeftTwoTone";
import RotateRightTwoToneIcon from "@mui/icons-material/RotateRightTwoTone";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import TuneIcon from "@mui/icons-material/Tune";
import "./mapData.scss";

const styles = {
  margin: 0,
  fontSize: "10px",
  color: "#202020",
};
const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "absolute",
  "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
    top: theme.spacing(1),
    left: theme.spacing(-2),
  },
}));

const MapToolBar = ({
  zoom,
  onClickZoom,
  rotateClick,
  fitToScreenClick,
  onClickChangeOrientation,
}) => {
  const [open, setOpen] = useState(false); // Track the state of the menu

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const actions = [
    {
      icon: (
        <ZoomOutIcon
          // onClick={(e) => onClickZoom("out")}
          onClick={(e) => {
            if (zoom > 1) {
              onClickZoom("out");
            }
          }}
          className="cursorPointer"
          color={zoom <= 1 ? "disabled" : "inherit"}
          disabled={zoom <= 1}
        />
      ),
      name: "Zoom Out",
    },
    {
      icon: (
        <h6 style={{ ...styles }}>{zoom <= 1 ? 0 : parseInt(zoom * 10)}%</h6>
      ),
      name: "Zoom Level",
    },
    {
      icon: (
        <IconButton className="p-4px">
          <ZoomInIcon
            onClick={(e) => onClickZoom("in")}
            className="cursorPointer"
            color={zoom === 10 ? "disabled" : "inherit"}
          />
        </IconButton>
      ),
      name: "Zoom In",
    },

    {
      icon: (
        <IconButton className="p-4px">
          <RotateRightTwoToneIcon
            onClick={(e) => rotateClick("right")}
            className="cursorPointer"
          />
        </IconButton>
      ),
      name: "Rotate Right",
    },
    {
      icon: (
        <IconButton className="p-4px">
          <AutorenewOutlinedIcon
            onClick={fitToScreenClick}
            className="cursorPointer"
          />
        </IconButton>
      ),
      name: "Refresh",
    },

    {
      icon: (
        <IconButton className="p-4px">
          <IconButton className="p-4px">
            <RotateLeftTwoToneIcon
              onClick={(e) => rotateClick("left")}
              className="cursorPointer"
            />
          </IconButton>
        </IconButton>
      ),
      name: "Rotate Left",
    },

    {
      icon: (
        <TuneIcon
          onClick={(e) => onClickChangeOrientation()}
          className="cursorPointer"
        />
      ),
      name: "Adjust boundary",
    },
  ];

  return (
    <Box className="mapTool-Wrap">
      <StyledSpeedDial
        ariaLabel="SpeedDial playground example"
        icon={<MenuIcon />}
        direction={"down"}
        open={open}
        onClick={handleOpen}
        onClose={handleClose}
        FabProps={{
          sx: {
            margin: "2px !important",
            bgcolor: "transparent !important", // Change the background color to transparent
            "&:hover": {
              bgcolor: "rgb(229, 34, 34)",
            },
          },
        }}
      >
        {actions.map((action) => {
          return (
            <SpeedDialAction
              className="MapToolSpeedAction"
              sx={{
                ...(action?.name === "Zoom Level" && { cursor: "not-allowed" }),
                ...(action?.name === "Zoom Level" && { cursor: "not-allowed" }),
              }}
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              FabProps={{
                sx: {
                  width: "60px",
                  "&:hover": {
                    bgcolor: "white",
                  },
                },
              }}
            />
          );
        })}
      </StyledSpeedDial>
    </Box>
  );
};

export default MapToolBar;
